export const convertRGBA = (rgba: {
  red?: number | undefined;
  green?: number | undefined;
  blue?: number | undefined;
  alpha?: number | undefined;
}) => {
  return `rgba(${rgba.red ?? 0}, ${rgba.green ?? 0}, ${rgba.blue ?? 0}, ${
    Math.floor(((rgba.alpha ?? 0) / 255) * 100) / 100
  })`;
};
